import { logGreyError } from 'owa-analytics';
import { trace } from 'owa-trace';

export default function logMissingHeaderButtonPaneError(headerPaneName: string, paneId: string) {
    logGreyError(
        'HeaderButtonPaneNotFound',
        new Error('No corresponding pane ID found for a header button.'),
        {
            headerPaneName,
            paneId,
        }
    );
    trace.warn(`Header pane with id ${paneId} not found. Header pane name: ${headerPaneName}`);
}
